export const GET_REPORTS = `/reports/get/requests`;
export const REPORT_PDF_DOWNLAOD = `/reports/pdf/download`;
export const AUTHENTICATE_USER = `/authenticate`;
export const VERIFY_USER = `/verify`;
export const GET_MANAGERS = `/employee/manager/get`;
export const GET_MANAGER_REQUESTS = `/manager/get/requests`;
export const MANAGER_ALL_COST_CONFIRM = `/manager/confirm/all`;

export const GET_ACCOUNTING_REQUESTS = `/accounting/get/requests`;
export const ACCOUNTING_REQUEST_CONFIRM = `/accounting/request/confirm`;
export const ACCOUNTING_REQUEST_CANCEL = `/accounting/request/cancel`;
export const ACCOUNTING_ALL_COST_CONFIRM = `/accounting/confirm/all`;

export const COST_CONFIRM_REQUEST = `/cost/confirm`;
export const COST_CANCEL_REQUEST = `/cost/cancel`;
export const GET_EMPLOYEES = `/verify/get/employees`;
export const UPDATE_EMPLOYEE = `/employee/update`;
export const GET_EMPLOYEE_CHANGES = `/employee/get-changes`;

export const COST_LIST = `/cost/list`;
export const COST_PDF_DOWNLOAD = `/cost/pdf/download`;
export const COST_SEND_APPROVAL = `/cost/send/approval`;
export const COST_DELETE = `/cost/delete`;
export const COST_UPDATE = `/cost/update`;
export const COST_ADD = `/cost/add`;
export const COST_PHOTO_DELETE = `/cost/photo/delete`;

export const CURRENT_EXCHANGE_RATE = `/exchangeRate/get `;
export const UPDATE_RECORDER_EXCHANGE_RATE = `/exchangeRate/update `;
export const UPDATE_USER_LANGUAGE = `/employee/updateLanguage`;
